'use client';

import { useStore } from '@/providers/app-store-provider';
import '@/styles/animations.css';
import { useEffect, useState } from 'react';
import SearchPart from './SearchPart';
import { useSearchStore } from './store/search-store';

interface SearchPopupPCProps {
  show: boolean;
  onClose: () => void;
}

const SearchPopupPC = ({ show, onClose }: SearchPopupPCProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const isSearchDataLoading = useSearchStore((state) => state.isSearchDataLoading);
  const token = useStore((state) => state.token);
  const refreshSearchHistory = useSearchStore((state) => state.refreshSearchHistory);

  useEffect(() => {
    if (show) {
      // 显示时立即设置可见
      setIsVisible(true);
      // 在下一帧添加动画类
      requestAnimationFrame(() => {
        setIsAnimating(true);
      });
    } else {
      // 隐藏时先开始动画
      setIsAnimating(false);
      // 等待动画结束后再移除DOM
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 200); // 与动画时长相同
      return () => clearTimeout(timer);
    }
  }, [show]);

  useEffect(() => {
    // 登录态刷新的时候，重新获取历史的搜索商品数据，更新里面的价格
    refreshSearchHistory();
  }, [token]);

  if (!isVisible) return null;

  return (
    <div className="absolute w-[690px] top-[42px] right-0 z-50 mt-1">
      <div
        className={`pt-[30px] pr-[70px] pb-[40px] pl-[60px] border border-[#e5e5e5] border-t-0 bg-white shadow-[0_3px_5px_0_rgba(0,0,0,0.1)] rounded-bl-[4px] rounded-br-[4px] box-border ${
          isAnimating ? 'searchPopupSlideDownAnimate' : 'searchPopupSlideUpAnimate'
        }`}
        style={{
          opacity: isAnimating ? 1 : 0,
          transform: `translateY(${isAnimating ? '0' : '-10px'})`,
          transition: 'opacity 0.2s ease-out, transform 0.2s ease-out',
        }}
      >
        {isSearchDataLoading ? (
          // 骨架屏：模拟搜索内容布局
          <div className="space-y-10">
            {/* 第一个区块骨架 */}
            <div>
              {/* 标题骨架 */}
              <div className="h-[12px] w-48 bg-gray-200 rounded-lg animate-pulse" />

              {/* 关键词标签骨架 - 模拟真实布局：第一个元素左对齐 */}
              <div className="flex flex-wrap mt-[12px]">
                {Array(8)
                  .fill(100)
                  .map((width, i) => (
                    <div
                      key={i}
                      className="h-[18px] bg-gray-200 rounded-[6px] animate-pulse mr-[12px] mb-[12px]"
                      style={{ width: `${width}px` }}
                    />
                  ))}
              </div>

              {/* 商品列表骨架 */}
              <div className="grid grid-cols-3 gap-[24px]">
                {[1, 2, 3, 4, 5, 6].map((item) => (
                  <div key={item} className="flex flex-col items-start">
                    {/* 商品图片骨架 */}
                    <div className="w-full max-w-[148px] h-[95px] bg-gray-200 rounded-lg animate-pulse" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* 搜索历史 */}
            <SearchPart type="history" onClose={onClose} />

            {/* 热门搜索 */}
            <SearchPart type="hot" onClose={onClose} />
          </>
        )}
      </div>
    </div>
  );
};

export default SearchPopupPC;
